/**
 * Parcels Details
 */

// React
import React, {FC, useEffect, useState} from 'react';

//UI
import {createStyles, makeStyles, Theme} from '@material-ui/core/styles';
import {Button, CircularProgress, Grid, Typography} from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import {mdiArrowRight} from '@mdi/js';

// Components
import ListParcelItems from './list';

// Type
import {Props} from './interfaces';
import parcelsRepository from 'client-sdk/src/Repository/parcels-repository';
import productRepository from 'client-sdk/src/Repository/product-repository';
import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotification';

export type Input = {
  serial: string;
};

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(0),
        },
      },
    },
    icon: {
      marginRight: theme.spacing(1),
    },
    headerBox: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '28px',
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
  })
);

const Details: FC<Props> = (props: Props): React.ReactElement => {
  const [filtersValues] = useState({
    page: 0,
    size: 100,
  } as any);
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [parcel, setParcel] = useState(null);
  const [products, setProducts] = useState(null);
  const [selectedProducts, setselectedProducts] = useState([]);

  const getParcelWithId = async (id: any) => {
    const payload = {id};
    try {
      setLoading(true);
      const response = await parcelsRepository.getParcelsWithId({payload});
      setParcel(response.data);
      const ids = response.data.items.map(el => el.inventoryItems[0].productId);
      // const codes = response.data.items.map(el => el.productCode);
      const {page, size} = filtersValues;
      getProducts({params: {
        ...filtersValues,
        page,
        size,
        status: "NOT_APPROVED"
        // sort: 'name,code,width,id,length,height',
      }, 
      data: [...new Set(ids)]
    });
    } catch (error) {
      handleError(error.response);
    }
  };
  const getProducts = async (payload: any) => {
    try {
      setLoading(true);
      const response = await productRepository.getProductByStatus({payload});
      setProducts(response.data);
    } catch (error) {
      console.log(error)
      handleError(error.response);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const {id} = props.match.params;
    getParcelWithId(id);
  }, [filtersValues]); // eslint-disable-line react-hooks/exhaustive-deps

  const selectProduct = id => {
    if (selectedProducts.indexOf(id) === -1) {
      setselectedProducts([...selectedProducts, id]);
      return;
    }
    const newList = selectedProducts.filter(el => el !== id);
    setselectedProducts(newList);
  };

  const selectAll = () => {
    if (selectedProducts.length > 0) {
      setselectedProducts([]);
      return;
    }
    setselectedProducts([...products.map(el => el.id)]);
  };

  const reloadList = () => {
    const ids = parcel.items.map(el => el.inventoryItems[0].productId);
    const {page, size} = filtersValues;
    getProducts({params: {
      ...filtersValues,
      page,
      size,
      status: "NOT_APPROVED"
      // sort: 'name,code,width,id,length,height',
    }, 
    data: [...new Set(ids)]
  });
  };

  const onSubmit = async () => {
    const payload = {
      description: '',
      ids: selectedProducts,
      status: 'APPROVED',
    };
    try {
      setLoading(true);
      const response = await productRepository.submitProducts({payload});
      handleNotfication('تایید مشخصات کالا با موفقیت انجام شد', 'success');
    } catch (error) {
      handleError(error.response);
    } finally {
      // setLoading(false);
      reloadList();
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.headerBox}>
        <Typography variant="h6" component="h2">
          {`
        تایید مشخصات کالا
        `}
        </Typography>
      </div>

      <Grid
        container
        direction="row"
        justify="space-between"
        alignItems="center"
        style={{
          marginBottom: '20px',
        }}
      >
        <Button
          aria-label="details"
          size="medium"
          onClick={() => window.history.back()}
        >
          <Icon path={mdiArrowRight} size={1} className={classes.icon} />
          {'بازگشت'}
        </Button>
      </Grid>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {loading ? (
            <div className={classes.loading}>
              <CircularProgress />
            </div>
          ) : (
            products && (
              <ListParcelItems
                data={products}
                selectProduct={selectProduct}
                selectedProducts={selectedProducts}
                selectAll={selectAll}
                reloadList={reloadList}
              />
            )
          )}
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        style={{
          marginTop: '20px',
        }}
      >
        <Button
          disabled={selectedProducts.length === 0}
          variant="contained"
          color="secondary"
          aria-label="details"
          size="medium"
          onClick={onSubmit}
        >
          تایید
        </Button>
      </Grid>
    </div>
  );
};

export default Details;
